// Entorno Desarrollo
export const environment = {
  production: false,
  appUrl: 'https://comparator-dev.techme.es/',
  apiUrl: 'https://comparator-onda-dev.azurewebsites.net/api',
  logLevel: 'debug',
  appTitle: 'DEV - Comparator',
};
